import { Globe, Monitor, Smartphone } from 'lucide-react';
import { APP_CONFIG } from '../../config/app';
import { PRICES } from '../../config/business';
import { MONTHLY_PRICE, SETUP_PRICE } from '../WebsiteOffer/offerData';
import type { ChatConversation, RoutingCardData } from './types';

/** Prix « à partir de » d'une réparation téléphone, lu dans la grille tarifaire. */
const priceFromOf = (id: string): number | null => PRICES.find((p) => p.id === id)?.priceFrom ?? null;

const SCREEN_PRICE = priceFromOf('ecran');
const BATTERY_PRICE = priceFromOf('batterie');

const PHONE_CARD_PRICE = [
  SCREEN_PRICE !== null ? `Écran dès ${SCREEN_PRICE} €` : null,
  BATTERY_PRICE !== null ? `Batterie dès ${BATTERY_PRICE} €` : null,
]
  .filter((part): part is string => part !== null)
  .join(' · ');

export const ROUTING_CARDS: readonly RoutingCardData[] = [
  {
    id: 'telephone',
    icon: Smartphone,
    title: 'Mon téléphone est cassé',
    description: 'Écran, batterie, vitre arrière, connecteur · à domicile',
    price: PHONE_CARD_PRICE,
    to: `${APP_CONFIG.routes.reparationTelephone}#devis`,
    featured: true,
  },
  {
    id: 'ordinateur',
    icon: Monitor,
    title: 'Mon ordinateur a un souci',
    description: 'PC & Mac, particuliers et entreprises · diagnostic gratuit',
    price: 'sur devis',
    to: APP_CONFIG.routes.depannage,
  },
  {
    id: 'site-web',
    icon: Globe,
    title: 'Je veux un site pour mon activité',
    description: 'Site pro clé en main, maintenance incluse',
    price: `${SETUP_PRICE} € puis ${MONTHLY_PRICE} €/mois`,
    to: APP_CONFIG.routes.creationSite,
  },
];

/** Une conversation par activité, jouées à tour de rôle dans le mockup. */
export const HERO_CONVERSATIONS: readonly ChatConversation[] = [
  {
    id: 'iphone',
    icon: Smartphone,
    messages: [
      { sender: 'user', text: 'L’écran de mon iPhone est fissuré, vous pouvez le remplacer ?', time: '10:15' },
      { sender: 'shop', text: 'Oui ! Je passe chez vous à Viry : diagnostic, prix annoncé, puis remplacement de l’écran.', time: '10:15' },
      { sender: 'user', text: 'Parfait, on fixe un rendez-vous !', time: '10:16' },
    ],
  },
  {
    id: 'pc',
    icon: Monitor,
    messages: [
      { sender: 'user', text: 'Bonjour, mon PC ne démarre plus depuis ce matin…', time: '14:02' },
      { sender: 'shop', text: 'Je peux passer faire un diagnostic gratuit, et je vous annonce le prix avant d’intervenir.', time: '14:03' },
      { sender: 'user', text: 'Super, demain matin c’est possible ?', time: '14:03' },
    ],
  },
  {
    id: 'site',
    icon: Globe,
    messages: [
      { sender: 'user', text: 'Je suis plombier à Saint-Julien, il me faudrait un site pour mon activité.', time: '18:40' },
      { sender: 'shop', text: 'Site pro clé en main : 350 € puis 80 €/mois, maintenance incluse, livré en 2 à 3 semaines.', time: '18:41' },
      { sender: 'user', text: 'Ça me va, on en parle ?', time: '18:42' },
    ],
  },
];
